import { render, staticRenderFns } from "./TransactionReport.vue?vue&type=template&id=508b9152&scoped=true"
import script from "./TransactionReport.vue?vue&type=script&lang=js"
export * from "./TransactionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508b9152",
  null
  
)

export default component.exports